// import { ADMIN_PREFIX_PATH } from 'config'
import React, { FC, useContext, useMemo } from 'react'
// import { useParams } from 'react-router'
import { FCC } from 'types'

type LeadProviderType = {
 leadId?: any
 //  route?: string
 from?: 'lead' | 'other'
 isTransferred?: boolean
 realtorId?: number
}

export const LeadDetailsContext = React.createContext<LeadProviderType>({})

const LeadDetailsProvider: FCC<LeadProviderType> = ({
 children,
 from,
 leadId,
 isTransferred,
 realtorId,
}) => {
 const { Provider } = LeadDetailsContext

 return (
  <Provider
   value={{
    leadId,
    // route,
    from,
    isTransferred,
    realtorId,
   }}
  >
   {children}
  </Provider>
 )
}

export default LeadDetailsProvider

export const useLeadDetails = () => useContext(LeadDetailsContext)
